<template>
  <div class="p-4 flex flex-col">
    <!-- Current hosting info  -->
    <div>
      <div v-if="selectedPanel == ''">
        <div class="flex items-center justify-between">
          <div>
            <gd-button @click="$emit('clickedBackButton')"> {{ $t('frontend_back') }} </gd-button>
          </div>

          <div>
            <gd-button
              size="auto"
              class="px-4"
              primary
              @click="showRecordEditor = !showRecordEditor"
            >
              {{ showRecordEditor ? $t('frontend_cancel') : $t('frontend_gduikit_add_record') }}
            </gd-button>
          </div>
        </div>
        <account-domain-record-editor
          v-if="showRecordEditor"
          :saving="savingRecord"
          @cancel="showRecordEditor = false"
          @save="addRecord"
          class="my-3"
        />

        <table
          class="min-w-max w-full table-fixed mt-8 border-b border-grey-200"
          :key="tableKey"
        >
          <thead>
            <tr
              class="
                text-grey-500 text-sm
                leading-normal
                border-b border-grey-200
              "
            >
              <th class="py-3 px-6 text-center w-1/12">{{ $t('frontend_type') }}</th>
              <th class="py-3 px-6 text-left w-3/12">{{ $t('frontend_name') }}</th>
              <th class="py-3 px-6 text-left w-4/12">{{ $t('frontend_content') }}</th>
              <th class="py-3 px-6 text-center w-1/12">TTL</th>
              <th class="py-3 px-6 text-center w-1/12">Proxied</th>
              <th class="py-3 px-6 text-center w-2/12">{{ $t('frontend_actions') }}</th>
            </tr>
          </thead>
          <tbody
            class="text-grey-800 text-sm -mx-4"
            :key="record.id"
            v-for="record in editableRecords"
          >
            <tr
              class="border-grey-200"
              v-if="!selectedRecord || selectedRecord.id !== record.id"
            >
              <td class="py-3 px-6 text-center w-1/12">
                {{ record.type }}
              </td>
              <td class="py-3 px-6 w-4/12 truncate">
                {{ record.name }}
              </td>
              <td class="py-3 px-6 w-4/12 truncate">
                {{ record.content }}
              </td>
              <td class="py-3 px-6 text-center w-1/12">
                {{ record.ttl }}
              </td>
              <td class="py-3 px-6 text-center w-1/12">
                <div class="flex flex-col items-center">
                  {{ record.proxied ? 'Yes' : 'No' }}
                </div>
              </td>
              <td class="py-3 px-6 text-center w-1/12">
                <div class="flex flex-row">
                  <gd-button
                    primary
                    size="icon"
                    class="mr-2"
                    @click="selectedRecord = record"
                  >
                    <i class="fas fa-edit"></i>
                  </gd-button>

                  <gd-button
                    primary
                    size="icon"
                    class="mr-2"
                    :loading="deletingRecord && deletingRecord.id === record.id"
                    @click="confirmDeleteRecord(record)"
                  >
                    <i class="fas fa-trash"></i>
                  </gd-button>
                </div>
              </td>
            </tr>
            <tr v-else-if="selectedRecord && selectedRecord.id === record.id">
              <td colspan="6">
                <account-domain-record-editor
                  :current="record"
                  :saving="savingRecord"
                  @cancel="selectedRecord = undefined"
                  @save="(data) => updateRecord({ id: record.id, ...data })"
                  class="my-3"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <confirm-modal
      @close="deletingRecord = undefined"
      @confirm="deleteRecord"
      name="delete-record"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Notify from '@groovepages/gd-lib/notify';
import GdButton from './Button';
import TextInput from './TextInput';
import CopyBtn from './CopyBtn';
import AccountDomainRecordEditor from './AccountDomainRecordEditor';
import GdModal from './Modal';

import ConfirmModal from './ConfirmModal';

export default {
  name: 'ZoneRecords',
  components: {
    GdModal,
    ConfirmModal,
    AccountDomainRecordEditor,
    CopyBtn,
    GdButton,
    TextInput,
  },
  computed: {
    ...mapGetters({
      records: 'records/records',
    }),
    editableRecords() {
      return this.$store.getters['records/records'].filter((value, index) => {
        return (
          value.content != 'host10.groovepages.com' &&
          value.content != 'get.groovesell.com' &&
          value.content != 'get.groovemember.net' &&
          value.content != 'get.groovekart.com'
        );
      });
    },
  },
  data() {
    return {
      tableKey: 1,
      selectedPanel: '',
      setUpDomain: false,
      setUpCustomDomain: false,
      showCname: false,
      setupGrooveDomain: false,
      errorMsg: '',
      domainColumns: [
        this.$t('frontend_type'),
        this.$t('frontend_name'),
        this.$t('frontend_content'),
        'TTL',
        'Proxy'
      ],
      newSubDomain: '',
      showCreateDomain: false,
      showRecordEditor: false,
      savingSub: false,
      loadingDomains: false,
      loadingRecords: false,
      savingRecord: false,
      togglingProxy: undefined,
      selectedRecord: undefined,
      deletingRecord: undefined,
      deletingDomain: undefined,
      selectedDomain: undefined,
      newDomain: {
        domain: '',
        hosted: true,
        platform: 'pages',
      },
      addingDomain: undefined,
      grooveSellLegacyDomains: [],
    };
  },
  created() {},
  methods: {
    showError(e) {
      console.error(e);
      if (e) {
        if (e && e.response && e.response.data.errors) {
          return Notify.fail(
            e.response.data.errors[0].message,
            e.response.data.errors.map(({ message }) => message).join('. ')
          );
        }
        return Notify.fail(e.message);
      }
    },
    async addRecord(data) {
      try {
        this.savingRecord = true;

        await this.$store.dispatch('records/addDnsRecord', {
          data,
        });
        Notify.success(this.$t('frontend_zone_records_successfully_added_dns'));
        this.showRecordEditor = false;
      } catch (e) {
        this.showError(e);
      } finally {
        this.savingRecord = false;
        this.selectedRecord = undefined;
      }
    },
    async updateRecord(data) {
      try {
        this.savingRecord = true;
        await this.$store.dispatch('records/updateDnsRecord', {
          data,
        });
        Notify.success(this.$t('frontend_zone_records_successfully_updated_dns'));
        this.selectedRecord = undefined;
      } catch (e) {
        this.showError(e);
      } finally {
        this.savingRecord = false;
        this.tableKey += 1;
      }
    },
    confirmDeleteRecord(record) {
      this.deletingRecord = record;
      this.$root.$emit('modal-open', 'delete-record');
    },
    async deleteRecord() {
      try {
        await this.$store.dispatch('records/deleteDnsRecord', {
          record: this.deletingRecord,
        });
        Notify.success(this.$t('frontend_zone_records_successfully_deleted_dns'));
        this.deletingRecord = undefined;
      } catch (e) {
        this.showError(e);
      }
    },
  },
};
</script>
